export function emitAction({ type, payload }) {
  return { type, payload };
}
